import { createSelector } from 'reselect'

import { RootState } from 'redux/store'
import { LayoutDeviceType } from 'interfaces/layout'

const selectDeviceType = createSelector(
  (state: RootState) => state.layout.deviceType,
  (deviceType: LayoutDeviceType) => deviceType
)

export default selectDeviceType
